'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.chatEvents = exports.onReady = exports.api = exports.user = exports.chat = undefined;

var _chatservice = require('./chatservice');

var _chatservice2 = _interopRequireDefault(_chatservice);

var _userservice = require('./userservice');

var _userservice2 = _interopRequireDefault(_userservice);

var _apiservice = require('./apiservice');

var _apiservice2 = _interopRequireDefault(_apiservice);

var _chatEvents = require('./chatEvents');

var _chatEvents2 = _interopRequireDefault(_chatEvents);

var _lib = require('../../../mqttclient/lib/');

var _lib2 = _interopRequireDefault(_lib);

var _constants = require('../common/constants');

var Constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import MessageDispatcher from './messagedispatcher'
function onReady(options) {
    return new Promise(function (resolve, reject) {
        window.sfChat = {};
        window.sfChat.baseApiUrl = options.baseApiUrl;
        _userservice2.default.addUser(options.user);
        _chatservice2.default.initialization(_lib2.default);
        _chatEvents2.default.setChatEventsCallback(options);

        _userservice2.default.get().then(function (userData) {
            var clientId = "$cid::" + userData.id + "$r::" + Math.floor(Math.random() * 1000 + 1);
            var willData = userData.offline_packet;
            var conOpts = { clientId: clientId, port: userData.mqtt.port, host: userData.mqtt.host, autoConnect: true, willData: willData };

            var callback = function callback(err, data) {
                if (err) {
                    console.error('Error connecting mqtt: ' + JSON.stringify(err));
                    reject({ status: "failed", message: "Unable to connect to remote messaging service" });
                }
                if (data.status === 'success') {
                    console.log(clientId + ' successfully connected');
                    _lib2.default.addConnectionStatusChangeCallback(onMqttConnectionStatusChange);
                    resolve({ status: "success", message: "successfully connected to remote messaging service" });
                }
                if (data.data === 'connecting') {
                    setTimeout(function () {
                        _lib2.default.connect(conOpts, callback);
                    }, 1000);
                }
            };

            _lib2.default.connect(conOpts, callback);
        });
    });
}

function onMqttConnectionStatusChange(options) {
    if (options.status === Constants.MQTT_ONLINE) {
        _userservice2.default.get().then(function (userData) {
            if (userData && userData.online_packet) {
                userData.online_packet.payload = JSON.stringify(userData.online_packet.payload);
                _lib2.default.publish(userData.online_packet);
            }
        });
    }
}

exports.chat = _chatservice2.default;
exports.user = _userservice2.default;
exports.api = _apiservice2.default;
exports.onReady = onReady;
exports.chatEvents = _chatEvents2.default;


// WEBPACK FOOTER //
// ../chat/lib/services/index.js